import React from "react";
import { Employee, Guardian, Person, Student, User } from "../../../../Utilities";
import { EmployeeIconNameDescription } from "../../Employee";
import { GuardianIconNameDescription } from "../../Guardian";
import { PersonIconNameDescription, PersonIconNameDescriptionProps } from "../../Person";
import { StudentIconNameDescription } from "../../Student";
import { UserIconNameDescription } from "../../User";

export type GeneralUserIconNameDescriptionProps = Omit<PersonIconNameDescriptionProps, "person"> & {
	user: Pick<User, "id" | "email"> & {
		person:
			| (Pick<Person, "id" | "name" | "publicName" | "imageURL" | "imageKey" | "imageContentType"> & {
					employee?: Pick<Employee, "id" | "jobTitle" | "role"> | null;
					guardian?: Pick<Guardian, "id"> | null;
					student?: Pick<Student, "id" | "graduationYear" | "yearsFromGraduation"> | null;
			  })
			| null;
	};
};

export function GeneralUserIconNameDescription({ user, ...props }: GeneralUserIconNameDescriptionProps) {
	const { employee, guardian, student } = React.useMemo(() => {
		if (!user.person) {
			return { employee: null, guardian: null, student: null };
		}

		const employee = user.person.employee ? { ...user.person.employee, person: user.person } : null;
		const guardian = user.person.guardian ? { ...user.person.guardian, person: user.person } : null;
		const student = user.person.student ? { ...user.person.student, person: user.person } : null;
		return { employee, guardian, student };
	}, [user]);

	if (!user.person) {
		return <UserIconNameDescription user={user} {...props} />;
	}

	if (employee) {
		return <EmployeeIconNameDescription employee={employee} {...props} />;
	}

	if (guardian) {
		return <GuardianIconNameDescription guardian={guardian} {...props} />;
	}

	if (student) {
		return <StudentIconNameDescription student={student} {...props} />;
	}

	return <PersonIconNameDescription person={user.person} {...props} />;
}
